
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSnowShowersPolartwilightColour as ObiLightSnowShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-snow-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightSnowShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-light-snow-showers-polartwilight-colour',
   elementClass: ObiLightSnowShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 